import { render, staticRenderFns } from "./BuchListen-Liste.vue?vue&type=template&id=ec823b9c&scoped=true&"
import script from "./BuchListen-Liste.vue?vue&type=script&lang=ts&"
export * from "./BuchListen-Liste.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec823b9c",
  null
  
)

export default component.exports